import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  getRecords,
  imageURL,
  saveRecords,
} from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { basicFormData, createPageData } from "./UserFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import formatDateTime from "../../../custom/Utils/formatDateTime.js";

const UserView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  // const [customerSelect, setCustomerSelect] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  // const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  // const [companyName, setCompanyName] = useState(false);
  // const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema:localStorage.getItem("schema"),
        whereCondition : { id: id, is_active: true },
        "include": [
          {
            "model": "role_masters",
            "as": "role"
          },
          {
            "model": "branch_masters",
            "as": "branch"
          }
        ]
      };

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  // const filteredItems =
  //   formData?.inputData?.list_details?.filter(
  //     (row) =>
  //       row?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       row?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase())
  //   ) || [];
  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>User Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              
                              
                              
                              <p>
                                <strong>First Name: </strong>
                                {formData?.inputData?.first_name || "-"}
                              </p>
                              <p>
                                <strong>Last Name: </strong>
                                {formData?.inputData?.last_name || "-"}
                              </p>
                              <p>
                                <strong>Email: </strong>
                                {formData?.inputData?.email_id || "-"}
                              </p>
                              <p>
                                <strong>Mobile No: </strong>
                                {formData?.inputData?.mobile_number || "-"}
                              </p>
                              <p>
                                <strong>Username: </strong>
                                {formData?.inputData?.username || "-"}
                              </p>
                            </Col>
                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Role: </strong>
                                {formData?.inputData?.role?.role_name ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Branch: </strong>
                                {formData?.inputData?.branch?.branch_name || "-"}
                              </p>
                              
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>

                              <p>
                                <strong>Created At: </strong>
                                {formData?.inputData?.createdAt === null ? "NA" : formatDateTime(formData?.inputData?.createdAt)}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {formData?.inputData?.updatedAt === null ? "NA" : formatDateTime(formData?.inputData?.updatedAt)}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      {formData?.inputData?.user_documents?.filter(
                        (row) => row.is_active
                      ).length > 0 && (
                        <Row className="mt-4">
                          <div className="item-list-container">
                            <div className="d-flex justify-content-between align-items-center">
                              <h6 className="h-6-heading">Attachments</h6>
                              <div className="app-search d-flex d-lg-inline mt-0 p-0"></div>
                            </div>
                            <div
                              className="table mt-2"
                              style={{
                                // overflow: "auto",
                                overflowX: "auto",
                                overflowY: "auto",
                                maxHeight: "500px",
                                width: "100%",
                                scrollBehavior: "smooth",
                                scrollbarWidth: "thin",
                                msOverflowStyle: "none",
                                zIndex: 0,
                              }}
                            >
                              <table className="table table-hover">
                                <thead
                                  style={{
                                    backgroundColor: "#8AC1E8",
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#8AC1E8",
                                    borderBottom: "1px solid black",
                                  }}
                                >
                                  <tr
                                    style={{ borderBottom: "1px solid black" }}
                                  >
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Sr. No
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Document
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      File
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formData?.inputData?.user_documents?.filter(
                                    (row) => row.is_active
                                  ).length > 0 ? (
                                    formData?.inputData?.user_documents
                                      .filter((row) => row.is_active)
                                      .map((row, index) => {
                                        if (!row) {
                                          return (
                                            <tr>
                                              <td
                                                colSpan="10"
                                                style={{ textAlign: "center" }}
                                              >
                                                No data available.
                                              </td>
                                            </tr>
                                          );
                                        }
                                        return (
                                          <React.Fragment key={id}>
                                            <tr>
                                              <td>{index + 1}</td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                {row?.document || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <img
                                                  src={imageURL + row?.file}
                                                  onClick={() =>
                                                    handleImageClick(
                                                      imageURL + row?.file
                                                    )
                                                  }
                                                  alt="Preview"
                                                  style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </td>
                                            </tr>
                                          </React.Fragment>
                                        );
                                      })
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="10"
                                        style={{ textAlign: "center" }}
                                      >
                                        No data available.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Row>
                      )}
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserView;
